import { getProjectBySlug } from '../../../../data/projects';
import { CaseStudyPage } from '../../../../components/caseStudy';

const project = getProjectBySlug('menya');

const MenyaPage = () => <CaseStudyPage project={project} />;

export default MenyaPage;
